import { useTheme } from "@material-ui/core";
import { Box, Typography } from "@material-ui/core";
import React from "react";

export const ErrorMessage = ({ errorMsg }) => {
  const { palette } = useTheme();
  return (
    <Box color={palette.danger.main}>
      <Typography variant="caption" className="m-0">
        {errorMsg}
      </Typography>
    </Box>
  );
};
